export default __webpack_public_path__ + "static/media/paper-plane.c6256e41.svg";